import Carousel from './src/main';
import CarouselItem from '../carousel/src/item';

Carousel.install = function(Vue) {
  Vue.component(CarouselItem.name, CarouselItem);
  Vue.component(Carousel.name, Carousel);
};

export default Carousel;
